import { render, staticRenderFns } from "./DataGridWrapper.vue?vue&type=template&id=901a6cf2"
import script from "./DataGridWrapper.vue?vue&type=script&lang=js"
export * from "./DataGridWrapper.vue?vue&type=script&lang=js"
import style0 from "./DataGridWrapper.vue?vue&type=style&index=0&id=901a6cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports